"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createButtonBarButton = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var ThemeProvider_1 = require("./lib/ThemeProvider");
var Button_1 = require("./Button");
function createButtonBarButton(params) {
    var Icon = params.Icon;
    var Button = Button_1.createButton({ Icon: Icon }).Button;
    var ButtonBarButton = react_1.memo(function (props) {
        var className = props.className, startIcon = props.startIcon, disabled = props.disabled, children = props.children, rest = __rest(props, ["className", "startIcon", "disabled", "children"]);
        var _a = useStyles(), classes = _a.classes, cx = _a.cx;
        return (jsx_runtime_1.jsx(Button, __assign({ className: cx(classes.root, className), variant: "secondary", startIcon: startIcon, disabled: disabled }, rest, { children: children }), void 0));
    });
    var useStyles = ThemeProvider_1.makeStyles({ "name": { ButtonBarButton: ButtonBarButton } })(function (theme) { return ({
        "root": {
            "backgroundColor": "transparent",
            "borderRadius": "unset",
            "borderColor": "transparent",
            "transition": "none",
            "& > *": {
                "transition": "none",
            },
            "&:hover.MuiButton-text": {
                "color": theme.colors.useCases.typography.textPrimary,
                "borderBottomColor": theme.colors.useCases.buttons.actionActive,
                "boxSizing": "border-box",
                "backgroundColor": "unset",
                "& .MuiSvgIcon-root": {
                    "color": theme.colors.useCases.typography.textPrimary,
                },
            },
            "&:active.MuiButton-text": {
                "color": theme.colors.useCases.typography.textFocus,
                "& .MuiSvgIcon-root": {
                    "color": theme.colors.useCases.typography.textFocus,
                },
            },
        },
    }); });
    return { ButtonBarButton: ButtonBarButton };
}
exports.createButtonBarButton = createButtonBarButton;
//# sourceMappingURL=ButtonBarButton.js.map